module.exports = "/_next/static/images/harajuku_cafe_cool-350e78157f45e467ba916644069b4ac3.jpg";